import { useEffect } from 'react';
import { useLoginWithOAuth, usePrivy } from '@privy-io/react-auth';
import { useAuthStore } from '../stores/authStore';
import { setUnauthorizedHandler } from '../lib/api';
import { toAuthUser } from '../lib/privy';

/**
 * Mirrors Privy's auth state into the Zustand store and wires the API
 * client's 401 handling to Privy's logout. Renders nothing.
 */
export function AuthBridge() {
  const { ready, authenticated, user, login, logout } = usePrivy();
  const { initOAuth } = useLoginWithOAuth();
  const bind = useAuthStore((s) => s._bind);
  const sync = useAuthStore((s) => s._sync);

  useEffect(() => {
    bind({
      signIn: () => login({ loginMethods: ['email', 'google'] }),
      signInWithEmail: () => login({ loginMethods: ['email'] }),
      signInWithGoogle: () => initOAuth({ provider: 'google' }),
      signOut: () => logout(),
    });
  }, [bind, login, logout, initOAuth]);

  useEffect(() => {
    sync({ user: ready && authenticated && user ? toAuthUser(user) : null, loading: !ready });
  }, [sync, ready, authenticated, user]);

  useEffect(() => {
    // If the API rejects our token (revoked session, app-id mismatch), drop the
    // client session so the user is routed to login instead of seeing endless 401s.
    setUnauthorizedHandler(() => {
      if (authenticated) void logout();
    });
    return () => setUnauthorizedHandler(null);
  }, [authenticated, logout]);

  return null;
}
